import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import IntroSection from "@/pages/home/components/IntroSection";
import Platforms from "@/pages/home/components/Platforms";
import TitlesExplorer from "@/pages/home/components/TitlesExplorer";
import SubtitleTypes from "@/pages/home/components/SubtitleTypes";
import Tips from "@/pages/home/components/Tips";
import FaqSection from "@/pages/home/components/FaqSection";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <IntroSection />
        <Platforms />
        <TitlesExplorer />
        <SubtitleTypes />
        <Tips />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}